module.exports = "<svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M15.455 5.203L6.87 13.907a1.38 1.38 0 0 1-1.944 0L.593 9.432c-1.78-1.765.851-4.434 2.592-2.627l2.43 2.464c.16.163.485.163.648 0l6.64-6.733c.284-.33.73-.535 1.215-.535 1.661-.042 2.51 2.01 1.337 3.202z\" fill-rule=\"evenodd\"/></svg>\n"


//////////////////
// WEBPACK FOOTER
// /www/client/src/components/Icon/check.svg
// module id = 332
// module chunks = 0